import dispatchError from 'app/redux/actions/error.action';
import { showSnackbar } from 'app/redux/actions/snackbar.action';

const fetchData = (actionType, apiCall, queryParams) => dispatch => {
  dispatch(pending(actionType));
  apiCall(queryParams)
    .then(payload => {
      dispatch(fulfilled(actionType, payload));
    })
    .catch(err => {
      dispatchError(dispatch, err, true);
      dispatch(rejected(actionType, err));
    });
};

const changeStatus = (TEMPLATE_NAME, apiCall, id) => dispatch => {
  dispatch(pending('CHANGE_STATUS_MODAL'));
  dispatch(pending(`${TEMPLATE_NAME}_REPLACE_IN_LIST`));
  apiCall(id)
    .then(payload => {
      dispatch(
        showSnackbar({
          title: `O item ${payload.name} foi ativado.`,
          action: true
        })
      );
      dispatch(fulfilled(`${TEMPLATE_NAME}_REPLACE_IN_LIST`, payload));
      dispatch(fulfilled('CHANGE_STATUS_MODAL'));
    })
    .catch(err => {
      dispatch(rejected(`${TEMPLATE_NAME}_REPLACE_IN_LIST`));
      dispatch(rejected('CHANGE_STATUS_MODAL', err));
    });
};

// REFACTOR O modal SAVE_UPDATE_MODAL deverá ser substituído por SIMPLE_FORM_MODAL
const insertData =
  ({ templateName: TEMPLATE_NAME, apiCall, dataToBeCreated, snackbarText }) =>
  dispatch => {
    dispatch(pending('SAVE_UPDATE_MODAL'));
    dispatch(pending(`${TEMPLATE_NAME}_ADD_IN_LIST`));
    apiCall(dataToBeCreated)
      .then(payload => {
        dispatch(
          showSnackbar({
            title: `O ${snackbarText} ${payload.name} foi criado.`,
            action: true
          })
        );
        dispatch(fulfilled(`${TEMPLATE_NAME}_ADD_IN_LIST`, payload));
        dispatch(fulfilled('SAVE_UPDATE_MODAL', payload));
      })
      .catch(err => {
        dispatchError(dispatch, err, true);
        dispatch(rejected(`${TEMPLATE_NAME}_ADD_IN_LIST`, err));
        dispatch(rejected('SAVE_UPDATE_MODAL', err));
      });
  };

// REFACTOR O modal SAVE_UPDATE_MODAL deverá ser substituído por SIMPLE_FORM_MODAL
const editData =
  ({ templateName: TEMPLATE_NAME, apiCall, id, dataToBeUpdated, snackbarText }) =>
  dispatch => {
    dispatch(pending('SAVE_UPDATE_MODAL'));
    dispatch(pending(`${TEMPLATE_NAME}_REPLACE_IN_LIST`));
    apiCall(id, dataToBeUpdated)
      .then(payload => {
        dispatch(
          showSnackbar({
            title: `O ${snackbarText} ${payload.name} foi atualizado.`,
            action: true
          })
        );
        dispatch(fulfilled(`${TEMPLATE_NAME}_REPLACE_IN_LIST`, payload));
        dispatch(fulfilled('SAVE_UPDATE_MODAL', payload));
      })
      .catch(err => {
        dispatch(rejected(`${TEMPLATE_NAME}_REPLACE_IN_LIST`, err));
        dispatch(rejected('SAVE_UPDATE_MODAL', err));
      });
  };

const insert =
  ({ templateName: TEMPLATE_NAME, apiCall, dataToBeCreated, snackbarText }) =>
  dispatch => {
    dispatch(pending('SIMPLE_FORM_MODAL'));
    dispatch(pending(`${TEMPLATE_NAME}_ADD_IN_LIST`));
    apiCall(dataToBeCreated)
      .then(payload => {
        dispatch(
          showSnackbar({
            title: `O ${snackbarText} ${payload.name} foi criado.`,
            action: true
          })
        );
        dispatch(fulfilled(`${TEMPLATE_NAME}_ADD_IN_LIST`, payload));
        dispatch(fulfilled('SIMPLE_FORM_MODAL', payload));
      })
      .catch(err => {
        dispatchError(dispatch, err, true);
        dispatch(rejected(`${TEMPLATE_NAME}_ADD_IN_LIST`, err));
        dispatch(rejected('SIMPLE_FORM_MODAL', err));
      });
  };

const edit =
  ({ templateName: TEMPLATE_NAME, apiCall, id, dataToBeUpdated, snackbarText }) =>
  dispatch => {
    dispatch(pending('SIMPLE_FORM_MODAL'));
    dispatch(pending(`${TEMPLATE_NAME}_REPLACE_IN_LIST`));
    apiCall(id, dataToBeUpdated)
      .then(payload => {
        dispatch(
          showSnackbar({
            title: `O ${snackbarText} ${payload.name} foi atualizado.`,
            action: true
          })
        );
        dispatch(fulfilled(`${TEMPLATE_NAME}_REPLACE_IN_LIST`, payload));
        dispatch(fulfilled('SIMPLE_FORM_MODAL', payload));
      })
      .catch(err => {
        dispatch(rejected(`${TEMPLATE_NAME}_REPLACE_IN_LIST`, err));
        dispatch(rejected('SIMPLE_FORM_MODAL', err));
      });
  };

export { fetchData, changeStatus, insertData, editData, insert, edit };

/**
 * Function to wrap the pending state type.
 * @param {String} type The state type.
 * @param {Object} payload The payload to be read by the reducer.
 */
export function pending(type, payload = null) {
  return {
    type: `${type}_PENDING`,
    payload
  };
}

/**
 * Function to wrap the rejected state type.
 * @param {String} type The state type.
 * @param {Object} payload The payload to be read by the reducer.
 */
export function rejected(type, payload = null) {
  return {
    type: `${type}_REJECTED`,
    payload
  };
}

/**
 * Function to wrap the fulfilled state type.
 * @param {String} type The state type.
 * @param {Object} payload The payload to be read by the reducer.
 */
export function fulfilled(type, payload = null) {
  return {
    type: `${type}_FULFILLED`,
    payload
  };
}
